import type { RaptorJobDto } from '@/libs/api-rest/generated/model/raptorJobDto';

export type NamedEntity = { id: number; name: string };

interface JobDataExtras {
  legacy?: boolean;
  calledAt?: string | null;
  confirmedAt?: string | null;
  cod?: boolean;
  poNumber?: string;
  salesAgentId?: number | null;
  salesAgent?: string | null;
  caller?: string | null;
  callerInfo?: NamedEntity | null;
  vendor?: NamedEntity | null;
  dispatcher?: NamedEntity | null;
  dispatchLocation?: NamedEntity | null;
  dispatcherId?: number | null;
  dispatchLocationId?: number | null;
  estimatedYards?: number | null;
  estimatedArea?: number | null;
  estimatedDuration?: number | null;
  flag1?: NamedEntity | null;
  flag2?: NamedEntity | null;
  flag3?: NamedEntity | null;
  timeZone?: string | null;
}

function asExtras(jobData: RaptorJobDto): JobDataExtras {
  return jobData as unknown as JobDataExtras;
}

export function extractEditModeJobData(jobData: RaptorJobDto) {
  const extras = asExtras(jobData);

  return {
    legacy: extras.legacy ?? true,
    calledAt: extras.calledAt ?? null,
    confirmedAt: extras.confirmedAt ?? null,
    cod: extras.cod ?? false,
    poNumber: extras.poNumber,
    salesAgentId: extras.salesAgentId ?? null,
    salesAgent: extras.salesAgent ?? null,
    caller: extras.caller ?? null,
    callerInfo: extras.callerInfo ?? null,
    vendor: extras.vendor ?? null,
    vendorId: extras.vendor?.id ?? null,
    dispatcher: extras.dispatcher ?? null,
    dispatchLocation: extras.dispatchLocation ?? null,
    dispatcherId: extras.dispatcherId ?? null,
    dispatchLocationId: extras.dispatchLocationId ?? null,
    estimatedVolume: extras.estimatedYards ?? null,
    estimatedArea: extras.estimatedArea ?? null,
    estimatedDuration: extras.estimatedDuration ?? null,
    flag1: extras.flag1 ?? null,
    flag2: extras.flag2 ?? null,
    flag3: extras.flag3 ?? null,
    flag1Id: extras.flag1?.id ?? null,
    flag2Id: extras.flag2?.id ?? null,
    flag3Id: extras.flag3?.id ?? null,
    timeZone: extras.timeZone ?? null
  };
}
